import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';

import './styles/GoBackButton.scss';

export default function GoBackButton({ alternativeRoute="/", className = '' }) {
  const goBackHandler = useGoBack(alternativeRoute);
  const buttonClassName = ['go-back__button', className].filter(Boolean).join(' ');

  return (
    <BackArrowIcon className={buttonClassName} onClick={goBackHandler} />
  );
}
